define('entities/phrases',[
  'app',
  'jquery',
  'backbone',
  'underscore',
  'settings',
  'backboneRelational',
  'entities/product_rel'
], function (
  App,
  $,
  Backbone,
  _,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = {ns: Backbone.Relational.store._modelScopes[0]};
  } else {
    app = {ns: {}};
    Backbone.Relational.store.addModelScope(app.ns);
  }

  var Phrase = Backbone.RelationalModel.extend({

    defaults: function () {
      return {
        code: '',
        internalName: new app.ns.DynamicText(),
        emailText: new app.ns.DynamicText(),
        proofsheetText: new app.ns.DynamicText()
      };
    },

    fetch: function () {
      this.url = Settings.url('compuzz2', 'v2/phrases/' + this.get('secId'));
      return Backbone.Model.prototype.fetch.call(this);
    },

    save: function () {
      this.url = Settings.url('compuzz2', 'v2/phrases');
      return Backbone.Model.prototype.save.call(this);
    },

    destroy: function () {
      this.url = Settings.url('compuzz2', 'v2/phrases/' + this.get('secId'));
      return Backbone.Model.prototype.destroy.call(this);
    },

    relations: [{
      type: Backbone.HasOne,
      key: 'internalName',
      relatedModel: 'DynamicText'
    }, {
      type: Backbone.HasOne,
      key: 'emailText',
      relatedModel: 'DynamicText'
    }, {
      type: Backbone.HasOne,
      key: 'proofsheetText',
      relatedModel: 'DynamicText'
    }],

    idAttribute: 'secId'
  });

  App.reqres.setHandler('phrases:model', function (value) {
    var col = Backbone.Relational.store.getCollection(Phrase);
    var model;
    if (value) {
      model = _.find(col.models, function (model) {
        return (value.secId && value.secId === model.get('secId')) ||
            (value.code && value.code === model.get('code'));
      });
    }
    if (model) {
      return model;
    } else {
      return new Phrase(value);
    }
  });

  App.reqres.setHandler('phrases:row-count-url', function (params) {
    return Settings.url('compuzz2', 'v2/phrases/rowCount', params);
  });

  App.reqres.setHandler('phrases:get-url', function (params) {
    return Settings.url('compuzz2', 'v2/phrases/advancedSearch', params);
  });
});

